import { render, staticRenderFns } from "./test_pay.vue?vue&type=template&id=f8fe5986&lang=pug&"
import script from "./test_pay.vue?vue&type=script&lang=js&"
export * from "./test_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports